/**
 * Dev only: bridge browser SIP (INVITE / answer / hangup) → POST /Paycall/webhook.
 * Paycall HTTP webhooks cannot reach localhost; the demo HTML uses the same pattern.
 *
 * In production, START / ANSWER / END arrive from Paycall's external webhooks —
 * the React client must NOT post them.
 */
export function isPaycallSipWebhookBridgeEnabled(): boolean {
  const raw = process.env.REACT_APP_PAYCALL_SIP_BRIDGE?.trim().toLowerCase();
  const nodeEnv = process.env.NODE_ENV;

  
  if (raw === "true" || raw === "1") {
    return true;
  }
  if (raw === "false" || raw === "0") {
    return false;
  }
  
  const defaultEnabled = nodeEnv === "development";
  return defaultEnabled;
}

/** Demo custid / recording URL inside dev bridge payloads only. */
export function paycallDevMockFieldsEnabled(): boolean {
  return isPaycallSipWebhookBridgeEnabled();
}
